/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import './service.scss';

const Services = () => {
  const [activeTab, setActiveTab] = useState('services');

  const services = [
    {
      title: "Website Development",
      desc: "Custom websites built from scratch with modern frameworks, responsive design, and optimized performance.",
      price: "₹16,000 (one-time)",
      features: [
        "Built with powerful React framework Next.js",
        "WordPress solutions also available",
        "Responsive design that works on all devices",
        "Serves as your digital business address"
      ]
    },
    {
      title: "SEO Optimization",
      desc: "Inline SEO setup, meta tags, site speed optimization, and technical improvements.",
      price: "Included in package",
      features: [
        "Keyword research and optimization",
        "Meta tags and schema markup",
        "Site speed optimization"
      ]
    },
    {
      title: "Cloud Deployment",
      desc: "Secure deployment on Cloudflare Pages with free SSL, CDN, and fast global delivery.",
      price: "Included in package",
      features: [
        "Secure Cloudflare deployment",
        "Free SSL certificate",
        "Global CDN for fast loading"
      ]
    },
    {
      title: "Maintenance & Updates",
      desc: "Monthly monitoring + 3 updates per month (text/images/design tweaks).",
      price: "₹1,600/month (after 8 months)",
      features: [
        "Monthly performance monitoring",
        "3 updates per month included",
        "Security updates and backups",
        "Separate update branches with date tracking"
      ]
    },
    {
      title: "Analytics Reporting",
      desc: "AI-powered monthly performance reports with insights from Google Search Console.",
      price: "Included in package",
      features: [
        "Live user tracking with Microsoft Clarity",
        "Heat map generator for user behavior",
        "Google Search Console integration"
      ]
    },
    {
      title: "Digital Advertising",
      desc: "Using your website as a platform for Meta Ads, Google Ads, and other digital campaigns.",
      price: "Starting at ₹4,000/month",
      features: [
        "Meta Ads (Facebook/Instagram) setup",
        "Google Ads campaign creation",
        "Conversion tracking implementation"
      ]
    },
    {
      title: "Domain & Asset Management",
      desc: "We handle domain registration, email setup, and GitHub repository management.",
      price: "₹1,200/year (domain) + Included setup",
      features: [
        "Domain registration and configuration",
        "Professional email setup with Gmail",
        "GitHub repository creation and management",
        "Full asset handover after launch"
      ]
    }
  ];

  const specialOffer = {
    title: "8-Month Special Package",
    desc: "Get our maintenance package with domain charges included at a discounted rate.",
    originalPrice: "₹12,800 (1600 × 8 months)",
    offerPrice: "₹12,000 (save ₹800)",
    includes: [
      "8 months of maintenance and updates",
      "Domain registration and renewal for 1 year",
      "All features of our standard maintenance plan"
    ]
  };

  const terms = [
    "All digital assets (domain, code, content) are handed over to the client after launch",
    "No refunds after assets have been delivered as the work is completed and ownership transferred",
    "Client has full rights to all delivered assets and can use them as needed",
    "Maintenance after the initial period is optional but recommended for optimal performance"
  ];

  return (
    <section className="services-section">
      <div className="section-header">
        <h2 className="section-title">Our Web Services</h2>
        <p className="section-subtitle">
          Comprehensive solutions to establish your digital presence and grow your business
        </p>
        
        <div className="tab-navigation">
          <button 
            className={`tab-button ${activeTab === 'services' ? 'active' : ''}`}
            onClick={() => setActiveTab('services')}
          >
            Services
          </button>
          <button 
            className={`tab-button ${activeTab === 'special' ? 'active' : ''}`}
            onClick={() => setActiveTab('special')}
          >
            Special Offer
          </button>
          <button 
            className={`tab-button ${activeTab === 'terms' ? 'active' : ''}`}
            onClick={() => setActiveTab('terms')}
          >
            Terms & Conditions
          </button>
        </div>
      </div>

      {activeTab === 'services' && (
        <>
          <div className="services-highlights">
            <div className="highlight-card">
              <div className="highlight-icon">👁️</div>
              <h3>Live User Tracking</h3>
              <p>Advanced Microsoft Clarity integration with heat maps to understand user behavior</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">⚛️</div>
              <h3>Modern Frameworks</h3>
              <p>Built with Next.js React framework or WordPress based on your needs</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">📊</div>
              <h3>Digital Advertising</h3>
              <p>Optimized for Meta Ads, Google Ads, and other digital marketing campaigns</p>
            </div>
          </div>

          <div className="services-list">
            {services.map((service, index) => (
              <div key={index} className="service-item">
                <div className="service-content">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-desc">{service.desc}</p>
                  {service.features && (
                    <ul className="service-features">
                      {service.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="service-price">{service.price}</div>
              </div>
            ))}
          </div>
        </>
      )}

      {activeTab === 'special' && (
        <div className="special-offer">
          <div className="offer-card">
            <div className="offer-badge">Special Offer</div>
            <h3 className="offer-title">{specialOffer.title}</h3>
            <p className="offer-desc">{specialOffer.desc}</p>
            
            <div className="pricing-comparison">
              <div className="original-price">{specialOffer.originalPrice}</div>
              <div className="arrow">↓</div>
              <div className="offer-price">{specialOffer.offerPrice}</div>
            </div>
            
            <div className="offer-includes">
              <h4>This package includes:</h4>
              <ul>
                {specialOffer.includes.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
            
            <button className="offer-cta">Get This Offer</button>
          </div>
          
          <div className="offer-note">
            <p>Note: Regular domain charges are ₹1,200/year. This special package includes domain charges along with 8 months of maintenance.</p>
          </div>
        </div>
      )}

      {activeTab === 'terms' && (
        <div className="terms-container">
          <h3>Important Terms & Conditions</h3>
          
          <div className="terms-list">
            {terms.map((term, index) => (
              <div key={index} className="term-item">
                <div className="term-number">{index + 1}</div>
                <div className="term-text">{term}</div>
              </div>
            ))}
          </div>
          
          <div className="assets-info">
            <h4>Asset Management Process:</h4>
            <ol>
              <li>We create a dedicated Gmail account for your business</li>
              <li>We register your domain and set up all necessary accounts</li>
              <li>We create a GitHub repository for your website code</li>
              <li>After launch, we provide full access to all assets</li>
              <li>We maintain separate update branches with clear dates for transparency</li>
            </ol>
          </div>
          
          <div className="refund-policy">
            <h4>Refund Policy:</h4>
            <p>No refunds are provided after assets have been delivered to the client. This is because we have already completed the work and transferred full ownership of all digital assets to you. You maintain complete rights to everything we've created.</p>
          </div>
        </div>
      )}

      <div className="services-cta">
        <h3>Ready to establish your digital presence?</h3>
        <p>Get a custom website that works as your digital address and marketing platform</p>
        <button className="cta-button">Get Started Today</button>
      </div>
    </section>
  );
};

export default Services;